<template>
	<div class="buyCard">
		<div class="buyCard-top">
			<div class="top-title">支付-首席联播|今日疯涨</div>
			<div class="top-card">
				<swiper ref="mySwiper" :options="swiperOptions">
				    <swiper-slide v-for="(item,index) in cardList" :key="index">
						<div class="top-card-item"  :class="setCardClass(item)" @click="chooseCard(item)">
							<div class="card-left">
								<div class="listen_num">{{ item.leftPromptText }}</div>
							</div>
							<div class="card-right">
								<div class="card-name">{{ item.chargeModeName }}</div>
								<div class="card-price">
									<span>{{ item.lvrfFee }}</span>
									<span>
										<img src="../../assets/img/pay/牛币.png" alt="" v-if="cardSelectedId == item.lvrvId">
										<img src="../../assets/img/recharge/牛币@2x.png" alt="" v-else>
									</span>
								</div>
								<div class="card-desc">
									<span>
										<s>{{ item.niubi }}</s>
									</span>
									<span v-if="item.niubi">
										<img src="../../assets/img/pay/牛币2.png" alt="" v-if="cardSelectedId == item.lvrvId">
										<img src="../../assets/img/recharge/牛币.png" alt="" v-else>
									</span>
								</div>
							</div>
						</div>
					</swiper-slide>
				    
					<swiper-slide v-for="(item,index,kk) in (4 - cardList.length%4)" :key="kk">
						<div class="top-card-item card_unselected">
							<div class="card-left">
								<div class="listen_num">待定</div>
							</div>
							<div class="card-right">
								<div class="card-name">暂无货品</div>
								<div class="card-price">
									<span></span>
									<span>
										<!-- <img src="../../assets/img/pay/牛币.png" alt="" v-if="cardSelectedId == item.lvrvId">
										<img src="../../assets/img/recharge/牛币@2x.png" alt="" v-else> -->
									</span>
								</div>
								<div class="card-desc">
									<span>
										<s>{{ item.niubi }}</s>
									</span>
									<span v-if="item.niubi">
										<img src="../../assets/img/pay/牛币2.png" alt="" v-if="cardSelectedId == item.lvrvId">
										<img src="../../assets/img/recharge/牛币.png" alt="" v-else>
									</span>
								</div>
							</div>
						</div>
					</swiper-slide>
					
				    <!-- <div class="swiper-pagination" slot="pagination"></div> -->
					<div class="swiper-button-prev" slot="pagination"></div>
					<div class="swiper-button-next" slot="pagination"></div>
					<!-- 如果需要滚动条 -->
					<div class="swiper-scrollbar"></div>
				  </swiper>
			</div>
		</div>
		<div class="buyCard-middle">
			<div class="middle-title">
				<span class="pay_desc">支付方式</span>
				<span class="pay_balance">（账户余额：{{ niubiBalance }}牛币）</span>
			</div>
			<div class="middle-paytype">
				<div class="middle-paytype-item wx-pay wxpay_selected" :class="{wxpay_selected:payTypeSelectedId == 1}" @click="choosePayType(1)">
					<img src="../../assets/img/recharge/arrow_icon.png" alt="" v-if="payTypeSelectedId == 1">
				</div>
				<div class="middle-paytype-item ali-pay alipay_selected" :class="{alipay_selected:payTypeSelectedId == 2}" @click="choosePayType(2)">
					<img src="../../assets/img/recharge/arrow_icon.png" alt="" v-if="payTypeSelectedId == 2">
				</div>
				<div class="middle-paytype-item balance-pay balancepay_selected" :class="{balancepay_selected:payTypeSelectedId == 0}" @click="choosePayType(0)">
					<img src="../../assets/img/recharge/arrow_icon.png" alt="" v-if="payTypeSelectedId == 0">
				</div>
			</div>
		</div>
		<div class="buyCard-bottom">
			<div class="sure-pay" @click="surePayBtn()">确认支付</div>
			<div class="bottom-pay-agreement">
				<div>
					<span class="agreementBtn" @click="agreeRechargeAgreement()">
						<input type="radio" name="agreeRecharge" :checked="radioSelected">
						请阅读并同意
					</span>
					<a href="javascript:;" style="color: red;font-size: 15px;" v-for="(item,index) in payInfoData.protocolList" @click="getAgreementDetail(item)">{{ item.proName }}</a>
				</div>
			</div>
			<!-- 支付二维码 -->
			<el-dialog 
			:visible.sync="isSurePayShow" 
			width="20%" 
			append-to-body 
			:close-on-click-modal="false"
			@close="isSurePayDialogClose">
				<div class="bottom-pay-code">
					<img :src="payQrCode" alt="">
				</div>
			</el-dialog>
			<!-- 支付协议 -->
			<el-dialog :visible.sync="isAgreementShow" width="60%" append-to-body>
				<iframe frameborder="0" width="100%" height="600px" :src="nowLookAgreementDetail"></iframe>
			</el-dialog>
			<!-- 实名认证 -->
			<v-identityCheck ref="identity"></v-identityCheck>
		</div>
	</div>
</template>

<script>
	import vAgreement from '../recharge/agreement'
	import vIdentityCheck from '../user/identityCheck'
	export default{
		name:"buyCard",
		data(){
			return {
				buyCardData:{
					goodsType:0,	//商品类型
					goodsId:0,		//商品ID
					sxUbId:0,		//首席ID
				},
				isAgreementShow: false,
				isSurePayShow:false,
				identityCheckDialog:false,
				radioSelected:0,
				payClassType:0,
				payTypeSelectedId:1,
				niubiBalance:0,
				//+----------------充值相关
				//卡片选中id
				cardSelectedId:0,
				activeBuyItem:[],
				payTypeSelectedId:1,
				//支付方式0牛币 1微信 2支付宝 3积分 4其他
				payInfoData:{},
				nowLookAgreementDetail:'',
				payType:1,
				payOrder:{
					orderId:0,
					orderNo:0,
				},
				payQrCode:'',
				checkPayTimer:'',
				payStatus:false,
				checkPayStatusTime:0,
				swiperOptions: {
					slidesPerView: 4,//显示个数
					direction: 'horizontal',
					loop: false, // 循环模式选项
					//分页
					pagination: {
						 el: ".swiper-pagination",
						 type: 'bullets',
						 clickable: true,
						 dynamicBullets: false
					},
					// 如果需要前进后退按钮
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev',
					},
					
					speed: 1000,
					// autoplay: {
					// 	 delay: 1000,
					// 	 disableOnInteraction: false
					// },
					effect: 'slide',
				},
				cardList:[],
				
				identityCheckResData:{},
			}
		},
		props:{
			liveDetailData:{
				type:Object,
			},
			goodsType:{
				type:Number,
				default:3,
			},
		},
		watch:{
			liveDetailData:'payDataHandle',
		},
		computed: {
		   swiper() {
		      return this.$refs.mySwiper.swiper
		   },
		},
		mounted(){
			// this.swiper.slideTo(3, 1000, false);
			
			//+--------处理组装变量、获取支付信息---------
			this.payDataHandle();
		},
		components:{
			'v-agreement':vAgreement,
			'v-identityCheck':vIdentityCheck
		},
		methods:{
			//数据处理
			payDataHandle(){
				/**
				 * 0牛人课、1牛视点、2金股池、3视频直播 、4斗牛商城、5资本价、
				 * 22知马策略、26直播秀打赏、27头条打赏、28斗牛TV礼物、
				 * 1021 模拟账户、1030 快问快答 1031 你问我答
				 */
				this.buyCardData.goodsType = this.goodsType;
				if(this.goodsType == 0){
					//+----------------------牛人课-------------------
					this.buyCardData.goodsId = this.liveDetailData.ncId;
					// this.buyCardData.sxUbId = this.liveDetailData.
				}else if(this.goodsType == 3){
					//+---------------------视频直播------------------
					this.buyCardData.goodsId = this.liveDetailData.lvrId;
					this.buyCardData.sxUbId = this.liveDetailData.lvrUbId;
				}else{
					this.$message.error('未知商品类型');
					return false;
				}
				
				/**
				 * 请求获取买卡页渲染数据
				 */
				this.getBuyCardPage();
			},
			//同意协议
			agreeRechargeAgreement(){
				this.radioSelected = !this.radioSelected;
			},
			//查看协议详情
			getAgreementDetail(item){
				this.nowLookAgreementDetail = item.proUrl;
				window.open(item.proUrl);
				// this.isAgreementShow = true;
			},
			//设置卡片class
			setCardClass(item){
				if(this.cardSelectedId == item.lvrvId){
					return [item.chargeModeKey,'selectedColor'];
				}else{
					return ['card_unselected','unselected_'+item.chargeModeKey];
				}
			},
			//选择买卡
			chooseCard(item){
				this.cardSelectedId = item.lvrvId;
				
				this.activeBuyItem = item;
			},
			//选择支付方式
			choosePayType(index){
				//更新支付方式下标
				this.payTypeSelectedId = index;
				//更新支付类型
				this.payType = index;
			},
			//获取买卡页数据
			getBuyCardPage(){
				//+-----------------------构建请求参数-----------------------
				let data = {
					pmAppVersion:this.store.state.pmAppVersion,
					applicationType:this.store.state.applicationType,
					goodsType:this.buyCardData.goodsType,
					goodsId:this.buyCardData.goodsId,
				};
				//+-----------------------请求买卡页数据--------------------
				this.apiServer.payment.payInfoByWeb(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message.error(res.data.data.businessMessage);
							return false;
						}
						
						//更新页面数据
						this.niubiBalance = res.data.data.dfNiubi;
						this.payInfoData = res.data.data;
						this.cardList = res.data.data.fees;
						//+---------------------类型为牛人课时--------------------
						if(this.goodsType == 0){
							this.cardList = res.data.data.goodsPriceList;
						}
						//默认选中第一个
						this.cardSelectedId = this.cardList[0].lvrvId;
						this.activeBuyItem = this.cardList[0];
					}
				})
				.catch(res => {
					this.$message.error('买卡支付页渲染异常');
				});
			},
			//点击确定支付
			surePayBtn(){
				//+-----------------------验证是否登录------------------
				if(!localStorage.getItem('user')){
					this.$message('请您登录后操作');
					return false;
				}
				//+---------------必须阅读并同意协议-------------
				if(this.radioSelected != 1){
					this.$message.error('请阅读并同意协议后操作');
					return false;
				}
				//+---------------验证是否实名-------------------
				let identityCheckRes = this.getIdentityCheckRes();
				if(this.identityCheckResData.idCardStatus != 1){
					this.$refs.identity.identityCheckDialog = true;
					return false;
				}
			
				//确定支付下单
				this.createBuyPayOrder();
			},
			//支付下单
			createBuyPayOrder(){
				//+-------------------------构建参数---------------------
				let data = {
					pmAppVersion:this.store.state.pmAppVersion,
					applicationType:this.store.state.applicationType,
					goodsId:this.buyCardData.goodsId,
					goodsType:this.buyCardData.goodsType,
					pmoType:0,
					payType:this.payType,
					rechargeFrom:1,
					//首席id
					sxUbId:this.buyCardData.sxUbId,
					chargeModeKey:this.activeBuyItem.chargeModeKey,
				};
				//+-------------------------请求支付下单-----------------
				this.apiServer.payment.createPayOrder(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message(res.data.data.businessMessage);
							return false;
						}
						
						//更新支付订单数据
						this.payOrder.orderId = res.data.data.pmoId;
						this.payOrder.orderNo = res.data.data.pmoOrder;
						
						//确认支付
						this.confirmBuyPay();
					}
				})
				.catch(res => {
					this.$message.error('支付下单异常');
				});
			},
			//确认支付
			confirmBuyPay(){
				//+---------------------构建请求参数--------------------
				let data = {
					applicationType:this.store.state.applicationType,
					orderId:this.payOrder.orderId,
					orderNo:this.payOrder.orderNo,
					payType:this.payType,
					pmoType:0,
					orderType:4,
					aliOrderType:2,
					goodsType:this.buyCardData.goodsType,
				};
				//+----------------------确认支付操作--------------------
				this.apiServer.payment.confirmBuyPay(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200){
						//+----------------余额支付-----------------------
						if(this.payType == 0){
							//牛币支付
						}
						//+---------------三方支付(二维码)显示------------
						if(this.payType == 1 || this.payType == 2){
							if(this.payType == 1){
								//微信支付
								this.payQrCode = "data:image/png;base64," + res.data.data.wechatInfo.base64Img;
							}
							
							if(this.payType == 2){
								//支付宝支付
								this.payQrCode = "data:image/png;base64," + res.data.data.aliInfo;
							}
							
							this.isSurePayShow = true;
						}
						
						//检查支付状态
						this.checkPayTimer = setInterval(() => this.checkBuyPayStatus(),1000);
					}
				})
				.catch(error => {
					console.log('确认支付操作异常');
					
				})
			},
			//获取支付结果
			checkBuyPayStatus(){
				//+----------------超时处理------------------------------
				if(this.checkPayStatusTime >= 300){
					this.isSurePayDialogClose();
					this.checkPayStatusTime = 0;
					this.$alert('支付行为已超时，请重试');
					return false;
				}
				this.checkPayStatusTime++;
				//+----------------------构建参数------------------------
				let data = {
					orderId:this.payOrder.orderNo,
				};
				//+----------------------获取支付结果--------------------
				this.apiServer.payment.checkBuyPayStatus(data)
				.then(res => {
					if(res.data.code == 200){
						if(res.data.data.code != 10){
							this.$message.error('参数无效');
							return false;
						}
						// console.log('-----支付状态------');
						// console.log(res.data.data);
						
						//未成功
						if(!res.data.data.payStatus){
							return false;
						}
						
						//支付成功，支付dialog关闭，清除定时器
						this.$message.success('支付成功');
						this.isSurePayDialogClose();
						setTimeout(() => {
							this.$router.go(0);
						},500);
					}
				})
				.catch(res => {
					this.$message.error('获取支付结果异常');
				});
			},
			//三方支付dialog关闭
			isSurePayDialogClose(){
				//清除定时器
				clearInterval(this.checkPayTimer);
				this.checkPayTimer = null;
				this.isSurePayShow = false;
			},
			//获取实名认证结果
			getIdentityCheckRes(){
				//身份证认证状态
				if(this.$refs.identity.checkRes.idCardStatus != 1){
					this.$refs.identity.identityCheckDialog = true;
				}
				this.identityCheckResData = this.$refs.identity.checkRes;;
			},
		}
	}
</script>

<style scoped>	 
	.buyCard{
		background: #FFFFFF;
	}
	
	.buyCard-top{
		/* border: 1px solid blue; */
	}
	
	.buyCard-top .top-title{
		width: 260px;
		height: 33px;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 33px;
		margin-bottom: 62px;
	}

	.agreementBtn{
		cursor: pointer;
	}
	.swiper-container {
		width: 100%;
	 }
	.swiper-wrapper{
		width: 100%;
	}

	.swiper-slide {
	  text-align: center;
	  font-size: 18px;
	  background: #fff;
	  height: 200px;
	  /* Center slide text vertically */
	  display: -webkit-box;
	  display: -ms-flexbox;
	  display: -webkit-flex;
	  display: flex;
	  -webkit-box-pack: center;
	  -ms-flex-pack: center;
	  -webkit-justify-content: center;
	  justify-content: center;
	  -webkit-box-align: center;
	  -ms-flex-align: center;
	  -webkit-align-items: center;
	  align-items: center;
	}
	
	.buyCard-top .top-card{
		/* border: 1px solid red; */
		
	}
	
	.buyCard-top .top-card .top-card-item{
		width: 150px;
		height: 200px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		cursor: pointer;
	}
	
	.top-card-item .card-left{
		width: 15%;
		display: flex;
		justify-content: space-around;
	}
	
	.top-card-item .card-right{
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		height: 80%;
	}
	
	.top-card-item .card-right .card-name{
		width: 26px;
		height: 80px;
		font-size: 28px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		/* color: #FFFFFF; */
		line-height: 40px;
	}
	
	.top-card-item .card-right .card-price{
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.card-price>span:nth-child(1){
		margin-right: 5px;
	}
	
	.top-card-item .card-right .card-price img{
		width: 18px;
	}
	
	.top-card-item .card-right .card-desc{
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.card-desc>span:nth-child(1){
		margin-right: 5px;
	}
	
	.top-card-item .card-right .card-desc img{
		width: 14px;
	}
	
	/* 卡片选择相关样式 */
	.top-card .card_unselected{
		background: url(../../assets/img/pay/card_unselected.png) no-repeat center;
		background-size: 100% 100%;
	}
	
	.top-card .selectedColor{
		color: #FFFFFF;
	}
	
	.top-card .Day{
		background: url(../../assets/img/pay/second_card.png) no-repeat center;
		background-size: 100% 100%;
	}
	
	.top-card .Week{
		background: url(../../assets/img/pay/week_card.png) no-repeat center;
		background-size: 100% 100%;
	}
	.top-card .Month{
		background: url(../../assets/img/pay/month_card.png) no-repeat center;
		background-size: 100% 100%;
	}
	.top-card .Quarter{
		background: url(../../assets/img/pay/season_card.png) no-repeat center;
		background-size: 100% 100%;
	}
	.top-card .HalfYear{
		background: url(../../assets/img/pay/half_year_card.png) no-repeat center;
		background-size: 100% 100%;
	}
	.top-card .Year{
		background: url(../../assets/img/pay/year_card.png) no-repeat center;
		background-size: 100% 100%;
	}
	.top-card .Forever{
		background: url(../../assets/img/pay/permanent_card.png) no-repeat center;
		background-size: 100% 100%;
	}
	
	.top-card .unselected_Day{
		color: #FF7874;
	}
	
	.top-card .unselected_Week{
		color: #FFA93F;
	}
	.top-card .unselected_Month{
		color: #F2D931;
	}
	.top-card .unselected_Quarter{
		color: #41A9FF;
	}
	.top-card .unselected_HalfYear{
		color: #5A7EF8;
	}
	.top-card .unselected_Year{
		color: #B37EEB;
	}
	.top-card .unselected_Forever{
		color: #1F2021;
	}
	
	
	.buyCard-middle{
		margin: 1.5625rem auto;
	}
	
	.buyCard-middle .middle-title{
		font-size: 18px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 1.875rem;
	}
	.buyCard-middle .middle-title>.pay_balance{
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 25px;
	}
	
	.middle-paytype{
		display: flex;
		justify-content: space-around;
		padding: 1.5625rem;
	}
	
	.buyCard-middle .middle-paytype .middle-paytype-item{
		padding: 2.5625rem;
		min-width: 15%;
		/* box-shadow: 2px 2px 20px 2px rgba(0,0,0,0.3); */
		cursor: pointer;
		position: relative;
	}
	
	.middle-paytype .middle-paytype-item img{
		position: absolute;
		right: 0;
		top: 74%;
	}
	
	.buyCard-middle .middle-paytype .wx-pay{
		background: url(../../assets/img/pay/微信未选中.png) no-repeat center;
		background-size: 100% 100%;
	}
	.buyCard-middle .middle-paytype .wxpay_selected{
		background: url(../../assets/img/pay/微信选中.png) no-repeat center;
		background-size: 100% 100%;
	}
	.buyCard-middle .middle-paytype .ali-pay{
		background: url(../../assets/img/pay/支付宝未选中.png) no-repeat center;
		background-size: 100% 100%;
	}
	.buyCard-middle .middle-paytype .alipay_selected{
		background: url(../../assets/img/pay/支付宝选中.png) no-repeat center;
		background-size: 100% 100%;
	}
	
	.buyCard-middle .middle-paytype .balance-pay{
		background: url(../../assets/img/pay/账户未选中.png) no-repeat center;
		background-size: 100% 100%;
	}
	.buyCard-middle .middle-paytype .balancepay_selected{
		background: url(../../assets/img/pay/账户选中.png) no-repeat center;
		background-size: 100% 100%;
	}
	.buyCard-bottom{
		margin: 0 auto;
		text-align: center;
		margin-top: 67px;
	}
	
	.buyCard-bottom .sure-pay{
		width: 300px;
		height: 64px;
		background: #C60B09;
		border-radius: 12px;
		margin: 0 auto;
		
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 60px;
		cursor: pointer;
	}
	
	.bottom-pay-code{
		width: 166px;
		height: 166px;
		margin: 0 auto;
	}
	
	.bottom-pay-code img{
		width: 100%;
		height: 100%;
	}
	
	.bottom-pay-agreement{
		text-align: center;
	}
	
	.bottom-pay-agreement a{
		text-decoration: none;
		font-size: 0.875rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #999999;
		line-height: 1.5625rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/buy_card.vue